import { RelevamientoNotificacion } from '../services/relevamientoService';

export const READ_STORAGE_KEY = 'incer.notif.relevamientos.read';
export const READ_SYNC_EVENT = 'incer.notif.relevamientos.read.changed';
export const NOTIFICATIONS_POLL_MS = 60_000;
export const NOTIFICATIONS_TAKE = 50;
export const DROPDOWN_VISIBLE_COUNT = 5;

export const RELEVAMIENTO_VIEW_PERMS = [
  { resource: 'relevamientos', action: 'list' },
  { resource: 'relevamientos', action: 'view_all' },
  { resource: 'relevamientos', action: 'view' },
  { resource: 'relevamientos', action: 'read' },
];

export function loadReadIds(): Set<number> {
  try {
    const raw = localStorage.getItem(READ_STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map((id) => Number(id)).filter((id) => !Number.isNaN(id)));
  } catch {
    return new Set();
  }
}

export function saveReadIds(ids: Set<number>) {
  localStorage.setItem(READ_STORAGE_KEY, JSON.stringify(Array.from(ids)));
  window.dispatchEvent(new CustomEvent(READ_SYNC_EVENT));
}

export function markIdsRead(ids: number[]): Set<number> {
  const next = loadReadIds();
  ids.forEach((id) => next.add(id));
  saveReadIds(next);
  return next;
}

export function markIdsUnread(ids: number[]): Set<number> {
  const next = loadReadIds();
  ids.forEach((id) => next.delete(id));
  saveReadIds(next);
  return next;
}

export function notificationTitle(item: RelevamientoNotificacion): string {
  return item.leyenda?.trim() || item.descripcion?.trim() || `Relevamiento #${item.id}`;
}

export function relativeTime(iso: string): string {
  try {
    const date = new Date(iso);
    const diffMs = Date.now() - date.getTime();
    const mins = Math.floor(diffMs / 60_000);
    if (mins < 1) return 'Ahora';
    if (mins < 60) return `Hace ${mins} min`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `Hace ${hours} h`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `Hace ${days} d`;
    return date.toLocaleDateString('es-AR');
  } catch {
    return iso;
  }
}

export function notificationLocation(item: RelevamientoNotificacion): string {
  return [item.clienteNombre, item.sucursalNombre].filter(Boolean).join(' · ');
}
